import { createElement } from 'react';
import { useDynamicUI } from './useDynamicUI';
import DonbarCheckout from '@Views/Settings/billing-settings/DonbarCheckout';

const useCheckout = () => {
    const open = useDynamicUI();

    return ({ height, priceId }) =>
        open(onClose =>
            createElement(DonbarCheckout, {
                open: true,
                onClose,
                height,
                priceId,
            }),
        );
};

export default useCheckout;
